import { Service } from '@toeverything/infra';

import type { Editor } from '../entities/editor';
import type { EditorScope } from '../scopes/editor';

export class EditorService extends Service {
  readonly editor = this.scope.props.editor;

  constructor(readonly scope: EditorScope<Editor>) {
    super();
  }
}
